import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["data-cy", "onClick"]
const _hoisted_2 = ["innerHTML"]

import { computed } from "vue";

import { VIconSvg } from "@/components";

interface Props {
  value: Array<{
    content?: string;
    id?: number;
    opened?: boolean;
    title: string;
  }>;
  itemLabel: string;
  trackBy: string;
  sortable: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VList',
  props: {
    value: { default: () => [
    {
      content: "",
      title: "",
    },
  ] },
    itemLabel: { default: "label" },
    trackBy: { default: "code" },
    sortable: { type: Boolean, default: false }
  },
  emits: ["clickItem", "input"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const draggableOptions = computed(() => {
  return { disabled: !props.sortable };
});

const onClickItem = (value: { content?: string; id?: number; opened?: boolean; title: string }) => {
  emit("clickItem", value);
};

const onInput = (value: { content?: string; id?: number; opened?: boolean; title: string }) => {
  emit("input", value);
};

return (_ctx: any,_cache: any) => {
  const _component_Draggable = _resolveComponent("Draggable")!

  return (_ctx.value.length)
    ? (_openBlock(), _createBlock(_component_Draggable, _mergeProps({ key: 0 }, { animation: 300 }, {
        "model-value": _ctx.value,
        "scroll-sensitivity": 300,
        "force-fallback": true,
        options: draggableOptions.value,
        handle: ".item",
        class: "list-wrapper",
        tag: "div",
        "onUpdate:modelValue": onInput
      }), {
        item: _withCtx(({ element, index }) => [
          _createElementVNode("div", {
            "data-cy": `list-item-${index}`,
            class: "item",
            onClick: ($event: any) => (onClickItem(element[_ctx.trackBy]))
          }, [
            _createElementVNode("span", {
              innerHTML: element[_ctx.itemLabel]
            }, null, 8, _hoisted_2),
            (_ctx.sortable)
              ? (_openBlock(), _createBlock(_unref(VIconSvg), {
                  key: 0,
                  class: "sort-icon",
                  name: "MoreVertical",
                  color: "fc-subduet",
                  "color-tag": "fill"
                }))
              : _createCommentVNode("", true)
          ], 8, _hoisted_1)
        ]),
        _: 1
      }, 16, ["model-value", "options"]))
    : _createCommentVNode("", true)
}
}

})